/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum EmployeePunishment {
    DEMOTION = 'Demotion',
    SUSPENSION = 'Suspension',
    REDUCTION_IN_PAY = 'ReductionInPay',
}
